<div class="card panel-flat-color secondary-panel tasks-assignement-ready-panel" style="overflow: initial">
    <div class="panel-flat-header mb-0">
        <div class="header-icon"><i class="fa fa-database"></i></div>
        <h3>Tasks/Assignment/Ready</h3>
    </div>
    <div class="panel-flat-body" style="min-height: 524px; overflow: initial">
        <div class="mb-3 form-group">
            <label for="action-view-task-type">Task Types:</label>
            <ws-select
                [options]="taskTypes"
                labelProperty="name"
                [returnEntireOption]="true"
                [isResultPlainText]="true"
                [optionTemplate]="optionTpl"
                [ngModel]="selectedTaskType"
                (ngModelChange)="selectTaskType($event)"
            ></ws-select>

            <ng-template #optionTpl let-option let-label="label">
                @if (option.taskTypeID === 0) {
                    <strong>{{ option.name }}</strong>
                } @else {
                    <span style="margin-left: 10px">{{ option.name }}</span>
                }
            </ng-template>
        </div>

        <fieldset class="mb-3 form-group">
            <legend class="h6 fw-bold">Show:</legend>
            @for (option of showOptions; track option.id) {
                @if (hasPrivatePermission || option.id === show.MyTasks || option.id === show.AllTasks) {
                    <div class="radio">
                        <label>
                            <input
                                type="radio"
                                name="action-view-show"
                                [value]="option.id"
                                [checked]="criteria.showChoice === option.id"
                                [disabled]="
                                    option.id === show.MyTasks && !hasPrivatePermission && !isTeamMemberAndAssignable
                                "
                                (change)="setShowChoice(option.id)"
                            />
                            {{ option.display }}
                        </label>
                    </div>
                    @if (option.id === show.SpecificIndividualsTasks && criteria.showChoice === option.id) {
                        <multi-user-team-picker
                            [includeInactiveContacts]="true"
                            [toBePickedArray]="criteria.showUserTeams"
                            (toBePickedArrayChange)="updatePicker('showUserTeams', $event)"
                        />
                    }
                    @if (option.id === show.SpecificTeamsTasks && criteria.showChoice === option.id) {
                        <multi-user-team-picker
                            [teamOnly]="true"
                            [toBePickedArray]="criteria.showTeams"
                            (toBePickedArrayChange)="updatePicker('showTeams', $event)"
                        />
                    }
                }
            }
        </fieldset>

        <fieldset class="mb-3 form-group">
            <legend class="h6 fw-bold">Where:</legend>
            @for (option of options.whereOptions; track option.id) {
                @if (canViewWhere(option)) {
                    <div class="radio">
                        <label>
                            <input
                                type="radio"
                                name="action-view-where"
                                [value]="option.id"
                                [checked]="criteria.whereChoice === option.id"
                                [disabled]="criteria.showChoice === show.AllTasks"
                                (change)="setWhereChoice(option.id)"
                            />
                            {{ option.display }}
                        </label>
                    </div>
                }
            }
        </fieldset>

        <fieldset class="mb-3 form-group">
            <legend class="h6 fw-bold">That are:</legend>
            @for (option of options.thatAreOptions; track option.id) {
                <div class="radio">
                    <label>
                        <input
                            type="radio"
                            name="action-view-that-are"
                            [value]="option.id"
                            [checked]="criteria.thatAreChoice === option.id"
                            (change)="setThatAreChoice(option.id)"
                        />
                        {{ option.display }}
                    </label>
                </div>
            }
        </fieldset>

        @if (criteria.thatAreChoice === thatAre.Completed) {
            <fieldset class="mb-3">
                <legend class="h6 fw-bold">Include:</legend>
                @for (option of options.includeOptions; track option.id) {
                    @if (canViewInclude(option)) {
                        <div class="radio">
                            <label>
                                <input
                                    type="radio"
                                    name="action-view-include"
                                    [value]="option.id"
                                    [checked]="criteria.includeChoice === option.id"
                                    (change)="setIncludeChoice(option.id)"
                                />
                                {{ option.display }}
                            </label>
                        </div>
                        @if (
                            option.id === include.CompletedBySpecificIndividual && criteria.includeChoice === option.id
                        ) {
                            <multi-user-team-picker
                                [userOnly]="true"
                                [toBePickedArray]="criteria.includeUserTeams"
                                (toBePickedArrayChange)="updatePicker('includeUserTeams', $event)"
                            />
                        }
                    }
                }
            </fieldset>
        }
    </div>
</div>
